import { createActions, handleActions } from 'redux-actions';
import Notifications from 'react-notification-system-redux';
import {
    defaultPaginationData,
    getPaginationAndOrderData,
} from '../../shared/utils';

const actions = createActions({
    CONTACT_REQUESTS: {
        LIST: {
            FILTER: filter => ({ filter }),
            REGIONS: regions => ({ regions }),
            FETCHING: currentPage => ({ currentPage }),
            LOADED: list => ({ list }),
        },
        REGIONS: {
            LOADED: list => ({ list }),
        },
        VIEW: {
            FETCHING: contactRequestId => ({ contactRequestId }),
            LOADED: contactRequest => ({ contactRequest }),
        },
        REMOVE: {
            PROMPT: ({ contactRequestId, contactRequestName }) => ({
                contactRequestId,
                contactRequestName,
            }),
            REMOVING: undefined,
            REMOVED: undefined,
            RESET: undefined,
        },
    },
});

const initialState = {
    list: Object.assign(
        {},
        {
            filter: null,
            error: null,
            fetching: false,
            fetchingTime: null,
            contactRequests: null,
            currentPage: 1,
            regions: null,
        },
        defaultPaginationData
    ),
    regions: {
        list: null,
    },
    view: {
        error: null,
        fetching: false,
        contactRequest: null,
    },
    remove: {
        contactRequestId: null,
        contactRequestName: null,
        removing: false,
    },
};

let fetchingTimer;

export default handleActions(
    {
        [actions.contactRequests.list.filter]: (state, action) => {
            return Object.assign({}, state, {
                list: Object.assign({}, state.list, {
                    filter: action.payload.filter,
                }),
            });
        },
        [actions.contactRequests.list.regions]: (state, action) => {
            return Object.assign({}, state, {
                list: Object.assign({}, state.list, {
                    regions: action.payload.regions,
                }),
            });
        },

        [actions.contactRequests.list.fetching]: (state, action) => {
            fetchingTimer = Date.now();

            return Object.assign({}, state, {
                list: Object.assign({}, state.list, {
                    fetching: true,
                    currentPage: action.payload.currentPage,
                }),
            });
        },
        [actions.contactRequests.view.fetching]: (state, action) => {
            return Object.assign({}, state, {
                view: Object.assign({}, initialState.view, {
                    fetching: true,
                }),
            });
        },

        [actions.contactRequests.list.loaded]: {
            next: (state, action) => {
                fetchingTimer = Date.now() - fetchingTimer;

                return Object.assign({}, state, {
                    list: Object.assign(
                        {},
                        state.list,
                        getPaginationAndOrderData(action.payload.list.meta),
                        {
                            contactRequests: action.payload.list.results.reduce(
                                (result, contactRequest) => {
                                    result[
                                        contactRequest.contactRequestId
                                    ] = contactRequest;
                                    return result;
                                },
                                {}
                            ),
                            fetching: false,
                            fetchingTime: fetchingTimer,
                        }
                    ),
                });
            },
            throw: (state, action) => {
                return Object.assign({}, state, {
                    list: Object.assign({}, initialState.list, {
                        error: true,
                    }),
                });
            },
        },

        [actions.contactRequests.regions.loaded]: {
            next: (state, action) => {
                return Object.assign({}, state, {
                    regions: Object.assign({}, state.stations, {
                        list: action.payload.list.reduce((result, region) => {
                            result[region.contactRequestRegionId] = region;
                            return result;
                        }, {}),
                    }),
                });
            },
            throw: (state, action) => {
                return Object.assign({}, state, {
                    list: Object.assign({}, initialState.list, {
                        error: true,
                    }),
                });
            },
        },

        [actions.contactRequests.view.loaded]: {
            next: (state, action) => {
                return Object.assign({}, state, {
                    view: Object.assign({}, initialState.view, {
                        contactRequest: Object.assign(
                            {},
                            action.payload.contactRequest
                        ),
                    }),
                });
            },
            throw: (state, action) => {
                return Object.assign({}, state, {
                    list: Object.assign({}, initialState.view, {
                        error: true,
                    }),
                });
            },
        },

        [actions.contactRequests.remove.prompt]: (state, action) => {
            const { contactRequestId, contactRequestName } = action.payload;

            return Object.assign({}, state, {
                remove: Object.assign({}, initialState.remove, {
                    contactRequestId,
                    contactRequestName,
                }),
            });
        },

        [actions.contactRequests.remove.removing]: (state, action) => {
            return Object.assign({}, state, {
                remove: Object.assign({}, state.remove, {
                    removing: true,
                }),
            });
        },

        [actions.contactRequests.remove.removed]: (state, action) => {
            return Object.assign({}, state, {
                remove: Object.assign({}, initialState.remove),
            });
        },

        [actions.contactRequests.remove.reset]: (state, action) => {
            return Object.assign({}, state, {
                remove: Object.assign({}, initialState.remove),
            });
        },
    },
    initialState
);

export const loadContactRequests = (currentPage, limit = 25) => {
    return (dispatch: Function, getState: Function, api: Function) => {
        const filter = getState().contactrequests.list.filter || '';
        const regions = getState().contactrequests.list.regions || [];
        let strRegions = '';
        for (const regionKey in regions) {
            strRegions += regionKey + ',';
        }

        dispatch(actions.contactRequests.list.fetching({ currentPage }));

        return api
            .get(
                `/contactrequests?limit=${limit}&page=${currentPage}&filter=${filter}&regions=${strRegions}`
            )
            .then(
                response =>
                    dispatch(
                        actions.contactRequests.list.loaded(response.data)
                    ),
                err => dispatch(actions.contactRequests.list.loaded(err))
            );
    };
};

export const filterContactRequests = filter => {
    return actions.contactRequests.list.filter(filter);
};
export const regionsContactRequests = regions => {
    return actions.contactRequests.list.regions(regions);
};

export const loadContactRequestRegions = () => {
    return (dispatch: Function, getState: Function, api: Function) => {
        return api
            .get('/contactrequests/regions')
            .then(response => {
                dispatch(actions.contactRequests.regions.loaded(response.data));
            })
            .catch(err => {
                dispatch(actions.sharedDataLoaded(err));
            });
    };
};

export const loadContactRequestView = contactRequestId => {
    return (dispatch: Function, getState: Function, api: Function) => {
        return api
            .get(`/contactrequests/${contactRequestId}`)
            .then(response => {
                dispatch(actions.contactRequests.view.loaded(response.data));
            })
            .catch(err => {
                dispatch(actions.contactRequests.view.loaded(err));
            });
    };
};

export const showDeleteContactRequestPrompt = (
    contactRequestId: string,
    contactRequestName: string
) => {
    return actions.contactRequests.remove.prompt({
        contactRequestId,
        contactRequestName,
    });
};

export const deletePromptReset = () => {
    return actions.contactRequests.remove.reset();
};

export const removeContactRequest = (
    contactRequestId: string,
    contactRequestName: string
) => {
    return (dispatch: Function, getState: Function, api: Function) => {
        dispatch(actions.contactRequests.remove.removing());

        return api.delete(`/contactrequests/${contactRequestId}`).then(
            response => {
                dispatch(actions.contactRequests.remove.removed());

                dispatch(
                    Notifications.success({
                        title: 'Contact Request deleted',
                        message: `The Contact Request ${contactRequestName} has been deleted.`,
                        position: 'tc',
                        autoDismiss: 3,
                    })
                );
            },
            err => {
                dispatch(actions.contactRequests.remove.removed(err));
                dispatch(
                    Notifications.error({
                        title: 'Delete failed',
                        message:
                            'An error occurred whilst deleting this contact request. Please try again.',
                        position: 'tc',
                        autoDismiss: 5,
                    })
                );
                throw err;
            }
        );
    };
};



// WEBPACK FOOTER //
// ./src/redux/reducers/contactrequests.js